<div class="templateBody">
  <div>
    <p class="link">News</p>
    <!-- <span *ngIf="canEdit">
      <button class="btn btn-default" (click)="toggleEditNews($event.target)" [innerText]="btnLabel"></button>
      <button class="btn btn-default" (click)="cancelEdit()" *ngIf="isEditing">Cancel</button>
    </span> -->
  </div>
  <div *ngIf="news && !isEditing" [innerHTML]="news.value"></div>
  <textarea *ngIf="isEditing" [innerHTML]="news.value" wrap="off" class="form-control" rows="30" #editText></textarea>
</div>